import React,{createContext,useContext,useEffect,useRef,useState,type ReactNode} from 'react';
import {Animated,Modal,View} from 'react-native';
import {useTokens} from '../theme/tokens';
import {Text,useCopy} from '../copy';
import {Icon} from './Icon';
import {WaitingDevice} from './measurement/MeasurementExperience';
import {ModelIcon} from '../../ModelIcon';
import {useLive} from '../live';
import {requestScope} from '../../../shared/request-scope.js';
import {saveFeedbackOutcome} from '../../../shared/save-feedback.js';

type Phase='working'|'success'|'error';
type Feedback={track:(work:Promise<unknown>)=>void};
const SaveFeedbackContext=createContext<Feedback>({track:()=>{}});

export function useSaveFeedback(){return useContext(SaveFeedbackContext);}

export function SaveFeedbackProvider({children}:{children:ReactNode}){
 const {state}=useLive(),{colors}=useTokens(),copy=useCopy(),reveal=useRef(new Animated.Value(0)).current;
 const [feedback,setFeedback]=useState<{phase:Phase;message:string;isCurrent:()=>boolean}|null>(null);
 const scope=useRef(requestScope()),timer=useRef<ReturnType<typeof setTimeout>|null>(null);
 const identity=JSON.stringify([state.address,state.accountEmail,state.signedIn,state.snapshot?.device?.id]);
 scope.current.select(identity);
 useEffect(()=>()=>{scope.current.invalidate();if(timer.current)clearTimeout(timer.current);},[]);
 const da=copy('Gem')==='Gem';
 const track=(work:Promise<unknown>)=>{
  scope.current.invalidate();const current=scope.current.capture();
  if(timer.current)clearTimeout(timer.current);
  setFeedback({phase:'working',message:'',isCurrent:current});
  const finish=(result:unknown)=>{
   if(!current())return;
   const outcome=saveFeedbackOutcome(result,da);
   setFeedback({phase:outcome.success?'success':'error',message:outcome.message,isCurrent:current});
   reveal.setValue(0);Animated.timing(reveal,{toValue:1,duration:300,useNativeDriver:true}).start();
   timer.current=setTimeout(()=>{if(current())setFeedback(null);},outcome.success?1800:3500);
  };
  void work.then(finish,()=>finish(false));
 };
 const phase=feedback?.isCurrent()?feedback.phase:null;
 return <SaveFeedbackContext.Provider value={{track}}>{children}{phase&&<Modal visible transparent animationType="fade" statusBarTranslucent onRequestClose={()=>{}}><View accessibilityLiveRegion="polite" accessibilityViewIsModal style={{flex:1,alignItems:'center',justifyContent:'center',padding:24,backgroundColor:'rgba(0,0,0,.42)'}}><View style={{width:'100%',maxWidth:420,alignItems:'center',gap:18,padding:28,borderRadius:24,backgroundColor:colors.surface,borderWidth:1,borderColor:colors.border}}>
  {phase==='working'?<WaitingDevice colors={colors} sessionKey={identity} renderIcon={()=><ModelIcon profile={state.snapshot?.device?.profile} size={44}/>} />:<Animated.View style={{width:72,height:72,borderRadius:36,alignItems:'center',justifyContent:'center',backgroundColor:'#FFFFFF',transform:[{translateX:reveal.interpolate({inputRange:[0,1],outputRange:[-12,0]})},{scale:reveal.interpolate({inputRange:[0,1],outputRange:[.75,1]})}],opacity:reveal}}><Icon name={phase==='success'?'check':'warning'} size={40} color={phase==='success'?colors.positive:colors.attention}/></Animated.View>}
  <Text style={{color:colors.text,fontSize:18,lineHeight:25,fontWeight:'800',textAlign:'center'}}>{phase==='working'?(da?'Vent et øjeblik – enheden opdateres':'Please wait – updating the device'):feedback?.message}</Text>
 </View></View></Modal>}</SaveFeedbackContext.Provider>;
}
